import type { FaireProductEntity } from "../../entity_types/product";

export const nyc_acc_6: FaireProductEntity = {
  token: "nyc-acc-6",
  type: "product",
  name: "Brooklyn Coffee Mug Set",
  brandName: "Brooklyn Ceramics",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/b3503ac0d6e409146515fd732ade635576645ea9ce25f9e3162a5e8b7af7f2fb.webp",
  priceDollars: 32,
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/b3503ac0d6e409146515fd732ade635576645ea9ce25f9e3162a5e8b7af7f2fb.webp",
  weight: 1.5,
  dimensions: {
    width: 4,
    height: 5,
    depth: 4,
  },
  description: "Handmade ceramic mug set from Brooklyn",
  categoryTokens: ["cat_accessories"],
  tags: ["nyc-local", "premium", "handmade", "ceramic"],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-compass-migration",
  },
};
